import {useState, type ReactNode} from "react";
import {useVisibility} from "@/tabletop/visibility/useVisibility.ts";
import {GameMasterViewSettingsContext} from "./GameMasterViewSettingsHooks.ts";

export default function GameMasterViewSettingsProvider({children}: {children: ReactNode}) {
    const [showPlayerSight, setShowPlayerSight] = useState(true);
    const [showHostileSight, setShowHostileSight] = useState(false);
    const [gmMaskOpacity, setGmMaskOpacity] = useState(0.6);
    // Share this relatively expensive visibility result between the map and combatant properties.
    const friendlyVisibility = useVisibility("friendly");

    return <GameMasterViewSettingsContext.Provider value={{showPlayerSight, setShowPlayerSight,
        showHostileSight, setShowHostileSight, gmMaskOpacity, setGmMaskOpacity, friendlyVisibility}}>
        {children}
    </GameMasterViewSettingsContext.Provider>;
}
